import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import type { StorageProvider } from '@cli-types/next-adapter/init.js'
import { STORAGE_INTEGRATIONS } from '@cli-constants/providers.js'

export function resolveFlagStorageProvider(
  explicitProvider: StorageProvider | undefined,
  integrations: BetterstartIntegrationId[]
): StorageProvider | undefined {
  const inferred = Array.from(
    new Set(
      integrations.filter((integration): integration is StorageProvider =>
        STORAGE_INTEGRATIONS.has(integration as StorageProvider)
      )
    )
  )

  if (inferred.length > 1) {
    throw new Error(`Choose only one storage integration. Received: ${inferred.join(', ')}.`)
  }

  const inferredProvider = inferred[0]
  if (explicitProvider && inferredProvider && explicitProvider !== inferredProvider) {
    throw new Error(
      `--storage-provider ${explicitProvider} conflicts with integration ${inferredProvider}.`
    )
  }

  if (explicitProvider === 'local' && inferredProvider) {
    throw new Error(`--storage-provider local conflicts with integration ${inferredProvider}.`)
  }

  return explicitProvider ?? inferredProvider
}
